import { render, staticRenderFns } from "./TranferAmount.vue?vue&type=template&id=72f3c1ff&"
import script from "./TranferAmount.vue?vue&type=script&lang=js&"
export * from "./TranferAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports